import { Component } from '@angular/core';
import { IDLinkModule } from '@inera/ids-angular/components/link';
import { IDMobileMenuModule } from '@inera/ids-angular/components/mobile/menu';
import { IDFooterIneraAdminComponent } from '@inera/ids-angular/components/footer-inera-admin';

@Component({
  selector: 'app-footer',
  imports: [IDFooterIneraAdminComponent, IDLinkModule, IDMobileMenuModule],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
})
export class AppFooterComponent {}
